import Modernizr from 'modernizr';

window.igglo.supportsObjectFit = Modernizr.objectfit;
window.igglo.supportsDateInput = Modernizr.inputtypes.date;

const loadingPolyfills = [];

/**
 * @template T
 * @param {function(): Promise<T>} tryFn Promise action to retry. Example: () => import('./A')
                                                 Receives next try's number and maxTries.
 * @returns {Promise<T>}
 */
function retry(tryFn) {
  return new Promise((resolve, reject) => {
    let tryCount = 0;

    const perform = () => tryFn()
      .then(resolve)
      .catch(error => {
        tryCount += 1;
        if (tryCount === 5) {
          reject(error);
        } else {
          setTimeout(perform, 1000);
        }
      });

    perform();
  });
}

if (!('scrollBehavior' in document.documentElement.style)) {
  loadingPolyfills.push(
    retry(() =>
      import(/* webpackChunkName: "scroll" */ 'seamless-scroll-polyfill')
    ).then(seamless => seamless.polyfill())
  );
}

if ([Element, CharacterData, DocumentType].some(it => !it.prototype.replaceWith)) {
  loadingPolyfills.push(retry(() =>
    import(/* webpackChunkName: "ReplaceWithPolyfill" */ './ReplaceWithPolyfill')
  ));
}

// Needed to decode UTF-8 bytes into string on JWT tokens.
// Needed by pre-chrome Edge, Safari <10.1 and iOS Safari <10.3
if (!window.TextDecoder) {
  loadingPolyfills.push(retry(() => import('fast-text-encoding')));
}

Promise.all(loadingPolyfills)
  .then(() => {
    window.igglo.polyfillsReady = true;

    if (window.igglo.runThisWhenPolyfillsAreReady) {
      window.igglo.runThisWhenPolyfillsAreReady();
    }
  });
